import React, { Children } from "react";
import { bool, func, node } from "prop-types";
import classNames from "classnames";

import Button from "pages/_components/Button";
import { useOnOutsideClick } from "hooks/useOnOutsideClick";

const MobileOptions = ({ children, isVisible, onToggle }) => {
    const handleToggle = () => onToggle(false);
    const { innerBorderRef } = useOnOutsideClick(handleToggle);

    return (
        <div className={classNames("slider", "slideFromBottom", { "is-shown": isVisible })}>
            <div className="slideFromBottom-wrapper" ref={innerBorderRef}>
                <Button block className="btn btn-link drawer-close" onClick={handleToggle} image="drawer-close.svg" />
                <ul className="navigational-list">
                    {Children.map(
                        children,
                        (child, index) =>
                            child &&
                            React.cloneElement(
                                <li
                                    className="navigational-list-item"
                                    key={`navigational-list-item ${Date.now() + index}`}>
                                    {child}
                                </li>,
                            ),
                    )}
                </ul>
            </div>
        </div>
    );
};

MobileOptions.propTypes = {
    children: node.isRequired,
    onToggle: func.isRequired,
    isVisible: bool,
};

MobileOptions.defaultProps = {
    isVisible: false,
};

export default MobileOptions;
